import { useQuery } from '@tanstack/react-query';

import type { CategoriesResponse } from '@/api/generated';
import { productsV3GetCategoriesOptions } from '@/api/generated/@tanstack/react-query.gen';
import type { ProductCategory } from '@/types/product.type';

function useGetProductCategoriesQuery() {
  return useQuery({
    ...productsV3GetCategoriesOptions({ query: { catalog: 'D2C' } }),
    select: transformToProductCategories,
  });
}

const transformToProductCategories = (data: CategoriesResponse): ProductCategory[] => {
  return data.payload.map((item) => ({
    uuid: item.uuid,
    parentUuid: item.parent_uuid || null,
    label: item.label,
    description: item.description || null,
    imageUrl: item.image_url || null,
  }));
};

export type { ProductCategory };
export { useGetProductCategoriesQuery };
